import React, { createContext, useContext, useEffect, useState, useCallback } from "react";

const LanguageContext = createContext(null);

const STORAGE_KEY = "sav_lang";

const getInitialLang = () => {
  try {
    const param = new URLSearchParams(window.location.search).get("lang");
    if (param === "ar" || param === "en") return param;
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored === "ar" || stored === "en") return stored;
  } catch (e) {
    /* noop */
  }
  return "en";
};

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    const dir = lang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem(STORAGE_KEY, lang);
    document.title =
      lang === "ar"
        ? "سمارت أكاونت فيجن للاستشارات الضريبية | ضرائب ومحاسبة وتدقيق في الإمارات"
        : "Smart Account Vision Tax Consultant | UAE Tax, Accounting & Auditing";
  }, [lang]);

  const toggle = useCallback(() => setLang(lang === "en" ? "ar" : "en"), [lang]);

  // t() accepts either a {en, ar} object or a plain string
  const t = useCallback(
    (value) => {
      if (value == null) return "";
      if (typeof value === "string") return value;
      return value[lang] ?? value.en ?? "";
    },
    [lang]
  );

  const dir = lang === "ar" ? "rtl" : "ltr";
  const isAr = lang === "ar";

  return (
    <LanguageContext.Provider value={{ lang, setLang, toggle, t, dir, isAr }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
